/* eslint "no-param-reassign": "warn" */
import MultiWeakMap from './MultiWeakMap';

// Method decorator that uses a MultiWeakMap to cache the results of calls
// for argument combinations previously seen before. See tests for examples.
export default (function (target, name, descriptor) {
  var decoratedMethod = descriptor.value;
  var arity = decoratedMethod.length;
  var cache = new MultiWeakMap(arity);
  descriptor.value = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length !== arity) {
      throw new Error("@withCachedArguments-decorated function expected ".concat(arity, " args but got ").concat(args.length));
    }
    if (cache.has(args)) {
      return cache.get(args);
    }
    var result = decoratedMethod.apply(this, args);
    cache.set(args, result);
    return result;
  };
  return descriptor;
});